(function( $ ) {
    $.fn.myForm = function()
    {
        let $el  = $(this);
        if(!$el.hasClass('no-ajax'))
        {
            $el.submit(function (event) {
                if(typeof CKEDITOR!=='undefined')
                {
                    if(typeof CKEDITOR.instances.content_detail!=='undefined')
                    {
                        CKEDITOR.instances['content_detail'].updateElement();
                    }
                }
                $.ajax({
                    type: $el.attr('method'),
                    url: $el.attr('action'),
                    data: $el.serialize() + '&_method=' + $el.attr('method'),
                    dataType: 'json',
                    encode: true,
                    beforeSend: function (xhr)
                    {
                        MessageBox.loading('open');
                    },
                    statusCode: {
                        503: function (data)
                        {
                            MessageBox.loading('hide');
                            MessageBox.error('<p style="color:red">ขออภัยค่ะ ท่านไม่มีสิทธิในการเข้าใช้งาน กรุณาติดต่อเจ้าหน้าที่</p>',function(){
                                window.location.reload(true);
                            });
                        },
                        500: function (data)
                        {
                            MessageBox.loading('hide');
                            MessageBox.error('<p style="color:red">ขออภัยค่ะ เกิดความผิดพลาด กรุณาติดต่อเจ้าหน้าที่</p>');
                        },
                        401: function (data)
                        {
                            MessageBox.loading('hide');
                            MessageBox.error('<p style="color:red">ขออภัยค่ะ กรุณาล็อกอินเข้าสู่ระบบก่อนค่ะ</p>',function(){
                                window.location.reload(true);
                            });
                        },
                        422: function (data)
                        {
                            MessageBox.loading('hide');
                            if(data.responseJSON.length >1)
                            {
                                var message = '<div style="text-align:left;"><ul style="list-style:none;margin:0;padding:0;">';
                                $.each(data.responseJSON, function (i, item) {
                                    message += '<li style="font-size:13px;"><i style="color:red;" class="fa fa-caret-right"></i> ' + item + '</li>';
                                });
                                message += '</ul></div>';
                            }
                            else
                            {
                                var message = '';
                                $.each(data.responseJSON, function (i, item) {
                                    message +=item + '<br/>';
                                });
                            }
                            MessageBox.error(message);
                        }
                    }
                }).done(function (data) {
                    MessageBox.loading('hide');
                    if(typeof data.modal!=='undefined')
                    {
                        let contener_edit = $('#modal-edit-content');
                        $('.modal-backdrop').remove();
                        //contener_edit.find('.modal').modal('hide');
                        contener_edit.empty().append(data.body);
                        contener_edit.find('.modal').each(function(i,e)
                        {
                            $(e).attr('data-backdrop','static');
                            $(e).attr('data-keyboard','false');
                        });
                        contener_edit.find('form').each(function(i,e)
                        {
                            $(e).myForm();
                        });
                        contener_edit.find('input.datepicker').each(function(i,e)
                        {
                            $(e).myDatePicker();
                        });
                        contener_edit.find('.datepicker-input').each(function (i, e) {
                            $(e).myDatePickerAlowInput();
                        });

                        contener_edit.find('select').each(function(i,e)
                        {
                            $(e).select2Build();
                        });
                        contener_edit.find('.modal').modal('show');

                        contener_edit.find('.uploadfile-btn').each(function(i,e){
                            $(e).uploadFile();
                        });
                        return false;
                    }
                    if(typeof data.remodal!=='undefined')
                    {
                        var contener_edit = $('#remodal-edit-content');
                        contener_edit.empty().append(data.body);
                        var options = {
                            closeOnEscape: true,
                            closeOnOutsideClick:true
                        };
                        var remodal = contener_edit.find('#remodal-window').remodal(options);
                        remodal.open();
                        return false;
                    }
                    if(typeof data.export!=='undefined')
                    {
                        if(data.export=='export-file')
                        {
                            var fm = '<form action="'+data.url+'" method="get" id="download_export_file"><input value="' + data.path + '" type="hidden" name="path"/><input value="' + data.name + '" type="hidden" name="name"/><input type="submit" id="downloadfilesubmit"/></form>';
                        }
                        else
                        {
                            var fm = '<form action="/export" method="get" id="download_export_file"><input value="' + data.file_name + '" type="hidden" name="p"/><input type="submit" id="downloadfilesubmit"/></form>';
                        }
                        $('body').append(fm);
                        $('#downloadfilesubmit').get(0).click();
                        $('#download_export_file').remove();
                        return false;
                    }
                    else if(typeof data.preview!=='undefined')
                    {
                        var fm='<form action="/preview-file" method="get" id="download_export_file"><input value="'+data.file_name+'" type="hidden" name="f"/><input type="submit" id="downloadfilesubmit"/></form>';
                        $('body').append(fm);
                        $('#downloadfilesubmit').get(0).click();
                        $('#download_export_file').remove();
                        return false;
                    }

                    if(typeof data.cb!=='undefined' && typeof window[data.cb]=='function')
                    {
                        window[data.cb](data);
                    }
                    else
                    {
                        let callback = function () {};
                        if (typeof callback_ajax === 'function') {
                            callback_ajax(data);
                        }
                        else {
                            if (Helper.is_notnull(data.type)) {
                                if (data.type == 'redirect') {
                                    callback = function () {
                                        window.location.href = data.url;
                                    }
                                }
                                else if (data.type == 'refresh') {
                                    callback = function () {
                                        location.reload(true);
                                    }
                                }
                                else {
                                    callback = function () {
                                    }
                                }
                            }
                            if (Helper.has(data.message)) {
                                MessageBox.alert(data.message, callback);
                            }
                        }
                    }
                });
                event.preventDefault();
            });
        }
    };

    $.fn.popupEditForm = function(url)
    {
        Helper.editContent(url,function(obj){
            if(typeof obj !='undefined')
            {
                if(typeof obj.export!=='undefined')
                {
                    if(obj.export=='export-file')
                    {
                        var fm = '<form action="'+obj.url+'" method="get" id="download_export_file"><input value="' + obj.path + '" type="hidden" name="path"/><input value="' + obj.name + '" type="hidden" name="name"/><input type="submit" id="downloadfilesubmit"/></form>';
                    }
                    else
                    {
                        var fm = '<form action="/export" method="get" id="download_export_file"><input value="' + obj.file_name + '" type="hidden" name="p"/><input type="submit" id="downloadfilesubmit"/></form>';
                    }
                    $('body').append(fm);
                    $('#downloadfilesubmit').get(0).click();
                    $('#download_export_file').remove();
                    return false;
                }
                else if(typeof obj.preview!=='undefined')
                {
                    var fm='<form action="/preview-file" method="get" id="download_export_file"><input value="'+obj.file_name+'" type="hidden" name="f"/><input type="submit" id="downloadfilesubmit"/></form>';
                    $('body').append(fm);
                    $('#downloadfilesubmit').get(0).click();
                    $('#download_export_file').remove();
                    return false;
                }
                if(typeof obj.remodal!=='undefined')
                {
                    let contener_edit2 = $('#remodal-edit-content');
                    contener_edit2.empty().append(obj.body);
                    var options = {
                        closeOnEscape: true,
                        closeOnOutsideClick:true
                    };
                    contener_edit2.find('input.datepicker').each(function(i,e)
                    {
                        $(e).myDatePicker();
                    });
                    contener_edit2.find('.datepicker-input').each(function (i, e) {
                        $(e).myDatePickerAlowInput();
                    });

                    contener_edit2.find('select').each(function(i,e)
                    {
                        $(e).select2Build();
                    });
                    contener_edit2.find('.uploadfile-btn').each(function(i,e){
                        $(e).uploadFile();
                    });

                    var remodal = contener_edit2.find('#remodal-window').remodal(options);
                    remodal.open();
                    return false;
                }

                let contener_edit = $('#modal-edit-content');
                $('.modal-backdrop').remove();
                contener_edit.find('.modal').modal('hide');
                contener_edit.empty().append(obj.body);
                contener_edit.find('.modal').each(function(i,e)
                {
                    $(e).attr('data-backdrop','static');
                    $(e).attr('data-keyboard','false');
                });
                contener_edit.find('form').each(function(i,e)
                {
                    $(e).myForm();
                });
                contener_edit.find('input.datepicker').each(function(i,e)
                {
                    $(e).myDatePicker();
                });
                contener_edit.find('.datepicker-input').each(function (i, e) {
                    $(e).myDatePickerAlowInput();
                });

                contener_edit.find('select').each(function(i,e)
                {
                    $(e).select2Build();
                });
                contener_edit.find('.modal').modal('show');

                contener_edit.find('.uploadfile-btn').each(function(i,e){
                    $(e).uploadFile();
                });
            }
        });
    }
}( jQuery ));
$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});
$('form').each(function(i,e){$(e).myForm();});
$(document).on('click','.edit-content',function(event){
    event.preventDefault();
    let url = $(this).attr('href');
    $.fn.popupEditForm(url);
});
$(document).on('click','.delete-content',function(event){
    event.preventDefault();
    var _that = this;
    MessageBox.confirm('ท่านต้องการที่จะลบรายการนี้ใช่หรือไม่',function()
    {
        let uri = $(_that).attr('href');
        Helper.deleteContent(uri, function (obj) {
            if (typeof obj != 'undefined') {
                MessageBox.alert(obj.message,function () {
                    window.location.reload(true);
                });
            }
        });
    });
});